// mixSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isMixSaved: false,
  isSavedPlaylist: false,
  mixId: null, // store full mix object or null if nothing is saved
  isModalIsOpenForSaveAndShare: false,
  isOpenShareMixModal: false,
  isOpenSaveMixModal: false,
  isOpenSaveSuccessMixModal: false,
  isMixerTrayOpen: false,
  sharingTraks: [],
};

const saveMixSlice = createSlice({
  name: "save_mix",
  initialState,
  reducers: {
    setSharingTracks: (state, action) => {
      const { item } = action.payload;
      const list = item?.sounds_list || []
      const modifiedArray = []
      list?.forEach((item) => {
        const detail = item.sounds_detail?.[0];
        if (!detail) return;
        modifiedArray.push(detail);
      });
      state.sharingTraks = modifiedArray;
    },
    setIsMixSaved: (state, action) => {
      state.isMixSaved = action.payload; // true / false
    },
    setIsSavedPlaylist: (state, action) => {
      state.setIsSavedPlaylist = action.payload; // true / false
    },
    setMixSavedId: (state, action) => {
      state.mixId = action.payload;
    },
    setModalIsOpenForSaveAndShare: (state, action) => {
      state.isModalIsOpenForSaveAndShare = action.payload;
    },
    handleShareMixModalGlobal: (state, action) => {
      state.isOpenShareMixModal = action.payload;
    },
    handleSaveMixModalGlobal: (state, action) => {
      state.isOpenSaveMixModal = action.payload;
    },
    handleSaveSuccessMixModal: (state, action) => {
      state.isOpenSaveSuccessMixModal = action.payload;
    },
    handleMixTrayGlobal: (state, action) => {
      if (window.innerWidth < 575) {
        document.body.style.overflow = action.payload ? 'hidden' : '';
      }
      state.isMixerTrayOpen = action.payload;
    },
  },
});

export const { setSharingTracks, setIsMixSaved, setIsSavedPlaylist, setMixSavedId, setModalIsOpenForSaveAndShare, handleShareMixModalGlobal, handleSaveMixModalGlobal, handleSaveSuccessMixModal, handleMixTrayGlobal } = saveMixSlice.actions;
export default saveMixSlice.reducer;
